import styled from 'styled-components'

import { CustomButton } from '../../../styles/global'

export const Title = styled.h3`
  font-size: 24px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  letter-spacing: 0.96px;
  padding-bottom: 8px;
  border-bottom: 1px solid #999999;
`
export const Subtitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
`
export const Row = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 23px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const InputContainer = styled.div`
  width: 48.5%;
`
export const SearchButton = styled(CustomButton)`
  border-radius: 8px;
`
export const SolicitationHistoryReadMore = styled.button`
  margin-bottom: 30px;
  margin-top: 10px;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.96px;
  color: #01878E;
  width: 100%;
  text-align: center;
  background: none;
  border: 0px;
  outline: 0px;
  cursor: pointer;

  &:disabled {
    display: none;
  }
`
